import { render, staticRenderFns } from "./QuoteRemarks.vue?vue&type=template&id=04be1244&scoped=true"
import script from "./QuoteRemarks.vue?vue&type=script&lang=js"
export * from "./QuoteRemarks.vue?vue&type=script&lang=js"
import style0 from "./QuoteRemarks.vue?vue&type=style&index=0&id=04be1244&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04be1244",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04be1244')) {
      api.createRecord('04be1244', component.options)
    } else {
      api.reload('04be1244', component.options)
    }
    module.hot.accept("./QuoteRemarks.vue?vue&type=template&id=04be1244&scoped=true", function () {
      api.rerender('04be1244', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/QuoteRemarks.vue"
export default component.exports